import { selectFilters } from '~/app/store/filter'
import { getMetadata } from '~/app/store/config/reducer'
import { filterOptionByIdSelector } from '~/app/store/filterOption'
import { FILTER_TYPE } from 'shared/constants'
import { createSelector } from 'reselect'
import { normalizeFilterType } from '~/app/features/Gallery/components/Filters/util'

export const getMetadataQueryParams = createSelector(getMetadata, selectFilters, filterOptionByIdSelector, (metadata, filters, getOption) => {
  const keywords = metadata?.keywords ?? []
  const categories = metadata?.categoryIds ?? []

  const colorFilter = filters.find((f) => normalizeFilterType(f.type) === FILTER_TYPE.COLOR)

  if (!keywords.length || !colorFilter) {
    return {
      categories,
      keywords,
      attributes: [],
    }
  }

  const colorOptions = (colorFilter as State.AttributeFilter).options.map(getOption)
  const colorDictionary: Record<string, string> = colorOptions.reduce(
    (accum, option) => ({
      ...accum,
      [option.title.toLocaleUpperCase()]: option.value,
    }),
    {},
  )

  const newKeywords: string[] = []
  const attributes: string[][] = []

  keywords.forEach((keyword) => {
    const colorAttribute = colorDictionary[keyword.toLocaleUpperCase()]

    if (colorAttribute) {
      attributes.push([colorAttribute])
    } else {
      newKeywords.push(keyword)
    }
  })

  return {
    categories,
    keywords: newKeywords,
    attributes,
  }
})
